// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OrcamentosServicos_ReativarOrcamentoServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /orcamentos_servicos/reativar_orcamento_servico
 *
 * Reactivates a cancelled orcamento_servico by setting status to 2.
 *
 * Data shape: boolean true on success
 *
 * @see Orcamentos_servicos::reativar_orcamento_servico()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type OrcamentosServicos_ReativarOrcamentoServicoResponseDados = boolean;

export type OrcamentosServicos_ReativarOrcamentoServicoResponse = ApiResponse<OrcamentosServicos_ReativarOrcamentoServicoResponseDados>;

registerResponseContract('OrcamentosServicos_ReativarOrcamentoServicoResponse', {})
